"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("@/common/functions");
function default_1({ channel_id, tax_type }) {
    let parsedData;
    try {
        parsedData = JSON.parse((0, functions_1.getCookie)('channel_tax_type'));
    }
    catch (_a) { }
    let data = '';
    if (!!parsedData) {
        parsedData[channel_id] = tax_type;
        data = JSON.stringify(parsedData);
    }
    else {
        data = JSON.stringify({ [channel_id]: tax_type });
    }
    console.log(data);
    (0, functions_1.saveCookie)({ name: 'channel_tax_type', value: data, path: '/' });
    (0, functions_1.saveCookie)({ name: 'tax_type', value: tax_type, path: '/' });
}
exports.default = default_1;
